// @desc: Simple react hook to which dispatches two actions

import { useCallback } from "react";
import { useDispatch } from "react-redux";
import {
  showAlert,
  closeAlert,
} from "../redux-toolkit/features/alert/alertSlice";

export const useAlert = () => {
  const dispatch = useDispatch();

  const displayAlert = useCallback(
    (alert) => {
      dispatch(showAlert(alert));
    },
    [dispatch],
  );

  const clearAlert = useCallback(
    (alert) => {
      dispatch(closeAlert(alert));
    },
    [dispatch],
  );

  return { displayAlert, clearAlert };
};
